








































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import TextField from '@/components/form/TextField.vue';
import UploadField from '@/components/form/UploadField.vue';
import Button from '@/components/Button.vue';
import SelectField from '@/components/form/SelectField.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import CheckboxField from '@/components/form/CheckboxField.vue';
import Loader from '@/components/Loader.vue';
import DateField from '@/components/form/DateField.vue';
import moment, { Moment } from 'moment';

@Component({
  components: {
    DateField,
    Loader,
    NewTranslation,
    TextField,
    UploadField,
    Button,
    SelectField,
    CheckboxField,
  },
})
export default class TransactionCancelOverlay extends Vue {
  @Prop({ type: Object, required: false })
  public transaction!: any | null;

  @Prop(Boolean)
  public isTransactionCancelling!: Boolean;

  public stayBegin: Moment | null = null;

  public stayEnd: Moment | null = null;

  public cancellationDocument: any = null;

  public cancellationIban: any = null;

  @Emit()
  public close(): void {}

  public submit(): void {
    if (
      !this.stayBegin ||
      !this.stayBegin.isValid() ||
      !this.stayEnd ||
      !this.stayEnd.isValid() ||
      !this.cancellationDocument ||
      !this.cancellationIban
    ) {
      return;
    }

    this.$emit('submit', {
      stayBegin: this.stayBegin,
      stayEnd: this.stayEnd,
      cancellationDocument: this.cancellationDocument,
      cancellationIban: this.cancellationIban,
    });
  }

  public date(date: any): any {
    return moment(date);
  }

  public created(): void {
    this.stayBegin = moment(this.transaction.stayBegin);
    this.stayEnd = moment(this.transaction.stayEnd);
  }

  public showInfo(title: string, message: string, submit: () => void): void {
    const overlayData: any = {
      title,
      message,
    };

    if (submit) {
      overlayData.submit = submit;
    }

    this.$store.commit('openOverlay', {
      overlayName: 'Info',
      overlayData: overlayData,
    });
  }
}
